const bodyLocations = [
  { id: 'scalp',                 label: 'Scalp',                     region: 'head' },
  { id: 'forehead',              label: 'Forehead',                  region: 'head' },
  { id: 'ear',                   label: 'Ear',                       region: 'head' },
  { id: 'outside_eye',           label: 'Outside eye',               region: 'head' },
  { id: 'eyeball',               label: 'Eyeball',                   region: 'head' },
  { id: 'nose',                  label: 'Nose',                      region: 'head' },
  { id: 'outside_mouth',         label: 'Outside mouth',             region: 'head' },
  { id: 'inside_mouth',          label: 'Inside mouth',              region: 'head' },
  { id: 'cheek_chin',            label: 'Cheek or chin',             region: 'head' },
  { id: 'neck',                  label: 'Neck',                      region: 'neck' },
  { id: 'chest',                 label: 'Chest',                     region: 'chest' },
  { id: 'upper_arm',             label: 'Upper arm or shoulder',     region: 'upper_arm' },
  { id: 'axilla',                label: 'Armpit',                    region: 'axilla' },
  { id: 'antecubital_fossa',     label: 'Inside elbow',              region: 'antecubital_fossa' },
  { id: 'abdomen',               label: 'Abdomen',                   region: 'abdomen' },
  { id: 'lower_arm',             label: 'Lower arm',                 region: 'lower_arm' },
  { id: 'finger',                label: 'Finger',                    region: 'hand' },
  { id: 'palmar_aspect_of_hand', label: 'Palm',                      region: 'hand' },
  { id: 'genital',               label: 'Genitals',                  region: 'genital' },
  { id: 'perianal',              label: 'Anus and surrounding area', region: 'buttocks' },
  { id: 'inguinal_fold',         label: 'Groin folds',               region: 'inguinal_fold' },
  { id: 'thigh',                 label: 'Thigh',                     region: 'thigh' },
  { id: 'buttocks',              label: 'Buttocks',                  region: 'buttocks' },
  { id: 'knee',                  label: 'Knee',                      region: 'knee' },
  { id: 'shin_calf',             label: 'Lower leg',                 region: 'shin_calf' },
  { id: 'dorsal_foot',           label: 'Top of foot or heel',       region: 'foot' },
  { id: 'toe',                   label: 'Toe',                       region: 'foot' },
  { id: 'toenail',               label: 'Toenail',                   region: 'foot' },
  { id: 'plantar_sole',          label: 'Bottom of foot',            region: 'foot' },
  { id: 'upper_back',            label: 'Upper back',                region: 'upper_back' },
  { id: 'lower_back',            label: 'Lower back',                region: 'lower_back' },
  { id: 'elbow',                 label: 'Elbow',                     region: 'elbow' },
  { id: 'dorsum_of_hand',        label: 'Back of hand',              region: 'hand' },
  { id: 'fingernail',            label: 'Fingernail',                region: 'hand' },
  { id: 'popliteal_fossa',       label: 'Back of knee',              region: 'popliteal_fossa' },
];

export default bodyLocations;
